module.exports = __webpack_public_path__ + "img/2.dec6a7ac.svg";